// extracted by mini-css-extract-plugin
module.exports = {"component":"style_component__19kP5","matchMsg":"style_matchMsg__2aW6A"};